import { Scrollbar } from 'swiper/modules';
import { SwiperProps } from 'swiper/react';

export const swiperParams: SwiperProps = {
  freeMode: false,
  slidesPerView: 'auto',
  grabCursor: true,
  centerInsufficientSlides: true,
  watchOverflow: true,
  scrollbar: {
    draggable: true,
    dragSize: 85,
  },
  modules: [Scrollbar],
};
